<style>
.glaze-default-content-wrapper {
  max-width: 1032px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 960px) {
    margin-top: 32px;
  }
}

.sidenav {
  width: 176px;
  font-size: 12px;
  font-weight: 500;
  padding-top: 24px;
}

.sidenav-element {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 32px;
  cursor: pointer;
  text-decoration: none;
  color: #000;
}

.sidenav-element--selected {
  background: #7e34ff;
  -webkit-box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, .5);
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, .5);
  color: #fff;
}

.content-background {
  background-color: #fafafa;
  min-height: 95vh;
}

.glaze-title {
  font-size: 28px;
  font-weight: 300;
  line-height: 47px;
  z-index: 2;
  letter-spacing: .96px;
  color: #022266;
}

.title-section {
  line-height: 47px;
  padding-top: 32px;
}

.dashboard-wrapper,
.purchases-wrapper {
  margin-left: 72px;
}

.content-section {
  margin-top: 24px;
}

.inputs-section {
  max-width: 510px;
}

.textfield {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
  font-weight: 300;
  margin-bottom: 16px;
}

.textfield label {
  width: 124px;
  font-size: 12px;
  font-weight: 500;
}

.textfield input {
  padding-left: 11px;
  flex-grow: 1;
  height: 33px;
  font-size: 16px;
  border: 1px solid #e7e7e7;
  outline: none;
  transition: all .1s ease-in-out;
  background-color: #fff;
}

.error-wrapper {
  padding-top: 8px;
  flex-direction: column;
  align-items: center;
  display: flex;
  height: 20px;
}

.error-string {
  color: red;
  font-size: 12px;
  letter-spacing: 0;
}

.submit-button {
  height: 62px;
  width: 296px;
  font-size: 14px;
  letter-spacing: 1.1px;
  background-color: #8946ff;
  border-radius: 6px;
  outline: none;
  border: none;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: all .1s ease-in-out;
  margin-top: 40px;
}

.submit {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.empty-bag-image {
  margin-top: 130px;
  height: 150px;
  width: 150px;
}

.empty-purchases-prompt {
  margin-top: 36px;
  font-size: 14px;
  color: #000;
  letter-spacing: .8px;
}

.section-title {
  font-size: 14px;
  color: #022266;
  font-weight: 500;
  margin-bottom: 8px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

.datatable {
  flex-grow: 1;
}

.datatable tr {
  border-bottom: 1px solid #dadada;
}

.datatable th {
  font-weight: 500;
  font-size: 14px;
  color: #505050;
}

.datatable td,
.datatable th {
  text-align: left;
  vertical-align: middle;
  font-size: 14px;
  height: 45px;
}

.item-price,
.item-title {
  font-weight: 400;
}

.datatable td:nth-child(n+3) {
  text-align: right;
  padding-right: 36px;
}

.illustration-image {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #eaeaea;
  background: #fff;
  width: 110px;
  height: 80px;
  margin: 4px;
}

.illustration-image img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  margin: auto;
}
</style>

<template>
  <div class="content-background">
    <v-content class="glaze-default-content-wrapper">
      <v-layout class="menu-layout">
        <v-flex no-grow>
          <div class="menu-container">
            <div class="mobile-menu-container">
              <div class="sidenav">
                <div class="sidenav-element" :class="{ 'sidenav-element--selected': currentPage === 'purchases' }"
                  @click="currentPage = 'purchases'">
                  Purchase History
                </div>
                <div class="sidenav-element" @click="logOut()">
                  Log Out
                </div>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex>
          <v-layout class="purchases-wrapper" column v-if="currentPage === 'purchases'">
            <v-flex class="title-section">
              <div class="glaze-title">Purchase History</div>
            </v-flex>
            <v-flex class="content-section">
              <v-layout column v-if="purchaseCount == 0">
                <v-flex class="text-xs-center">
                  <img src="@/assets/illustrations/empty-bag.png" class="empty-bag-image" />
                </v-flex>
                <v-flex class="text-xs-center empty-purchases-prompt">
                  No purchases have been made, <a class="link">browse illustrations</a>
                </v-flex>
              </v-layout>
              <v-layout column v-if="purchaseCount > 0">
                <div class="section-title">PURCHASES</div>
                <table class="datatable">
                  <tr>
                    <th></th>
                    <th class="text-xs-left table-header">Title</th>
                    <th class="text-xs-left table-header">Price</th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr v-for="(purchase, index) in userData.purchases" :key="index">
                    <td class="item-title">
                      <v-flex no-grow class="illustration-image">
                        <img :src="imageThumbUrl(purchase.image_id)">
                      </v-flex>
                    </td>
                    <td class="item-price desktop-cell">
                      {{ purchase.title }}
                    </td>
                    <td class="item-price text-xs-left desktop-cell">
                      {{ formatPrice(purchase.price) }}
                    </td>
                    <td class="desktop-cell">
                      <a class="download link desktop-cell" @click="downloadLink(purchase.bundle_id)">
                        Download
                      </a>
                    </td>
                    <td class="desktop-cell">
                      <a :href="purchase.transaction.receipt_url" target="_blank" class="link desktop-cell">
                        View Receipt
                      </a>
                    </td>
                  </tr>
                </table>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<script>
import ProfileInfo from "@/views/account/ProfileInfo";
import { mapGetters } from "vuex";
import { signOut } from "@/js/auth";
import { formatPrice } from "@/js/text";
import { getImageDownloadLink } from "@/js/api";

export default {
  mounted: function () { },
  methods: {
    logOut() {
      signOut();
      this.$router.push(`/`);
    },
    signOut: signOut,
    async downloadLink(bundleId) {
      let link = document.createElement("a");
      link.setAttribute("type", "hidden");
      let downloadUrl = await getImageDownloadLink(bundleId);
      link.href = downloadUrl;
      link.dispatchEvent(
        new MouseEvent(`click`, {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    },
    imageThumbUrl: function (imageId) {
      return `${process.env.VUE_APP_IMAGES_ROOT}${imageId}/thumbs/464.png`;
    },
    formatPrice: formatPrice
  },
  data() {
    return {
      currentPage: 'purchases',
      errorMessage: "",
      purchases: [],
    };
  },
  components: {
    ProfileInfo
  },
  computed: {
    ...mapGetters(["userData"]),
    purchaseCount() {
      if (!this.userData || !this.userData.purchases) {
        return 0;
      }
      return this.userData.purchases.length;
    },
    hasPurchases() {
      console.log(this.userData);
      return (!!this.userData && !!this.userData.purchases && this.userData.purchases.length > 0);
    }
  }
}
</script>
